import { render, staticRenderFns } from "./BusinessObjHeader.vue?vue&type=template&id=f3c557ae&scoped=true&"
import script from "./BusinessObjHeader.vue?vue&type=script&lang=js&"
export * from "./BusinessObjHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c557ae",
  null
  
)

export default component.exports